/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} So_Lot_Status_Awaiting_InvoiceInputs */

const en_so_lot_status_awaiting_invoice = /** @type {(inputs: So_Lot_Status_Awaiting_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipped, awaiting invoice`)
};

/**
* | output |
* | --- |
* | "Shipped, awaiting invoice" |
*
* @param {So_Lot_Status_Awaiting_InvoiceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const so_lot_status_awaiting_invoice = /** @type {((inputs?: So_Lot_Status_Awaiting_InvoiceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<So_Lot_Status_Awaiting_InvoiceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_so_lot_status_awaiting_invoice(inputs)
});